export default "__VITE_ASSET__BjcQEGlD__"